import React from "react";
import Home from "../../component/Home";

export const Homepage = () => {
  return (
    <div>
      <Home />
    </div>
  );
};

export default Homepage;
